function getNumChassis(e) {
    var numChassis = e.id;
    $.ajax({
        url: 'operations/historique',
        method: 'GET',
        data: {numChassis: numChassis},
        success: function(data) {
            $('#panelOperationHistorique').html(data);
        },
        error: function (xhr) {
            throw new xhr;
        }
    });
}

function initFilter() {
    $('#new').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:""}]);
    $('#pending').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:""}]);
    $('#payment').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:""}]);
    $('#closed').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:""}]);
}

function evolugridFilterByData(evolugridId, field, value) {
    $('#formEvolugrid input[name="value"]').val(value);
    $('#formEvolugrid input[name="field"]').val(field);
    $('#'+evolugridId).evolugrid('refresh', 0, [{name:"field", value:field}, {name:"value", value:value}]);
}

$(document).ready(function(){
    $('#formEvolugrid').on('click', function (e) {
        e.preventDefault();
        var value = $('#search').val();

        $('#new').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:value}]);
        $('#pending').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:value}]);
        $('#payment').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:value}]);
        $('#closed').evolugrid('refresh', 0, [{name:"all", value:1}, {name:"value", value:value}]);
    });
});
